module.exports = __webpack_public_path__ + "static/img/surity.5bcadc6f.png";